module.exports = __webpack_public_path__ + "img/up.09fd53d3.svg";